export default "__VITE_ASSET__RAllfjNT__"